import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "desc-error"
}
const _hoisted_2 = { class: "error" }
const _hoisted_3 = { class: "close-error" }
const _hoisted_4 = { class: "error-header" }
const _hoisted_5 = { class: "error-details" }
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "i", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 0,
  title: "When contacting the help desk, please quote this error details",
  class: "error-details-text"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "error-details-header" }, " Error Details: ", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

import { isAxiosError } from "axios";
import log from "loglevel";
import { ref, computed, watch } from "vue";
export interface IErrorInfoProps<T> {
    showError: boolean;
    closeError?: boolean;
    errorTitle?: string;
    errorDescription?: string;
    errorDisplayText?: string;
    error?: unknown;
    change?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorInfo',
  props: {
    showError: { type: Boolean, default: false },
    closeError: { type: Boolean, default: false },
    errorTitle: { default: "Error" },
    errorDescription: {},
    errorDisplayText: { default: "Your request could not be fulfilled at this moment due to a ServerOrClient1 errorServerOrClient2, please try again later. If this error persists, please raise a ticket with the help desk." },
    error: {},
    change: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const showErrorDetails = ref(false);
const showError = ref(props.showError);
const serverError = computed(isServerError);

function ToggleErrorDetails() {
    showErrorDetails.value = !showErrorDetails.value;
}
function isServerError() {
    return isAxiosError(props.error) && (props.error.status ?? 404) > 400;
}
watch(
    () => props.change,
    () => {
        log.debug("Changer changed");
        showError.value = props.showError;
    }
);

return (_ctx: any,_cache: any) => {
  return (showError.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.closeError)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showError.value = false))
                }, "X"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.errorTitle) + " " + _toDisplayString(_ctx.errorDescription) + ":", 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.errorDisplayText
                        .replace(
                            "ServerOrClient1",
                            serverError.value ? "server-side" : "client"
                        )
                        .replace(
                            "ServerOrClient2",
                            serverError.value ? "" : " (an error with your request)"
                        )), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              onClick: ToggleErrorDetails,
              title: _ctx.errorTitle
            }, _hoisted_8, 8, _hoisted_6)
          ]),
          _hoisted_9,
          (showErrorDetails.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                (_unref(isAxiosError)(_ctx.error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(`${_ctx.error}`.endsWith(".")
                            ? `${_ctx.error}`.slice(0, -1)
                            : `${_ctx.error}`) + _toDisplayString(_ctx.error?.response?.statusText ? ` ${(
                        _ctx.error?.response?.statusText
                    )}` : '') + " - message: " + _toDisplayString(_ctx.error?.response?.data?.Error) + ". ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.error), 1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})